import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ICustomEditorLabelService = ( createDecorator('ICustomEditorLabelService'));
export { ICustomEditorLabelService };
